import { formatAmount, toSmallestUnit, fromSmallestUnit } from '../../utils/formatters'
import { CurrencyInput } from '../ui'

interface RecordPaymentAdvanceProps {
  advanceBalance: number
  advanceAccountCode: string
  advanceApplied: number | null
  invoiceCurrency: string
  outstandingBalance: number
  paymentAmount: number | null
  setAdvanceApplied: (v: number | null) => void
  setPaymentAmount: (v: number | null) => void
}

export function RecordPaymentAdvance({
  advanceBalance, advanceAccountCode, advanceApplied,
  invoiceCurrency, outstandingBalance, paymentAmount,
  setAdvanceApplied, setPaymentAmount,
}: RecordPaymentAdvanceProps): JSX.Element | null {
  if (advanceBalance <= 0) { return null }

  return (
    <div className="rounded-lg border border-blue-200 dark:border-blue-700 bg-blue-50 dark:bg-blue-900/30 el-p-sm">
      <div className="flex items-center justify-between gap-4">
        <div className="text-sm text-blue-800 dark:text-blue-200">
          <span className="font-medium">Advance Available:</span>{' '}
          <span className="font-mono">{formatAmount(advanceBalance, invoiceCurrency)}</span>
          <span className="text-blue-600 dark:text-blue-300 text-xs ml-1">({advanceAccountCode})</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-xs text-blue-700 dark:text-blue-300 whitespace-nowrap">Apply:</span>
          <div className="w-36">
            <CurrencyInput
              hideMessage
              currency={invoiceCurrency}
              size="sm"
              value={advanceApplied}
              onChange={(val) => {
                const maxAdv = fromSmallestUnit(advanceBalance, invoiceCurrency)
                const capped = Math.min(val ?? 0, maxAdv, outstandingBalance)
                setAdvanceApplied(capped > 0 ? capped : null)
                setPaymentAmount(Math.max(0, outstandingBalance - capped))
              }}
            />
          </div>
        </div>
      </div>
      {(advanceApplied ?? 0) > 0 && (
        <div className="text-xs text-blue-700 dark:text-blue-300 mt-1">
          Cash to pay: <span className="font-mono font-medium">{formatAmount(toSmallestUnit(paymentAmount ?? 0, invoiceCurrency), invoiceCurrency)}</span>
        </div>
      )}
    </div>
  )
}
